import { forwardRef } from 'react';

import { IconProps } from './icons.types';

export const RefreshIcon = forwardRef<SVGSVGElement, IconProps>(function LogsIcon(
  { color = '', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.31766 2.47319C3.79102 1.2441 6.02147 0 9 0C14.0033 0 18 4.03346 18 9C18 13.1772 15.1551 16.6862 11.2948 17.703C10.9595 17.7913 10.616 17.5911 10.5277 17.2558C10.4394 16.9204 10.6396 16.5769 10.9749 16.4886C14.2979 15.6133 16.7442 12.5921 16.7442 9C16.7442 4.72375 13.3065 1.25581 9 1.25581C6.39434 1.25581 4.43875 2.33916 3.12211 3.43751C2.60963 3.86503 2.19683 4.2927 1.88433 4.65488H4.34512C4.6919 4.65488 4.97302 4.93601 4.97302 5.28279C4.97302 5.62957 4.6919 5.9107 4.34512 5.9107H0.627907C0.281124 5.9107 0 5.62957 0 5.28279V1.46512C0 1.11833 0.281124 0.837209 0.627907 0.837209C0.97469 0.837209 1.25581 1.11833 1.25581 1.46512V3.4761C1.5524 3.1595 1.90625 2.81638 2.31766 2.47319Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.627907 8.37209C0.97469 8.37209 1.25581 8.65322 1.25581 9C1.25581 9.34328 1.27815 9.68107 1.32138 10.0121C1.36629 10.3559 1.12395 10.6711 0.780085 10.716C0.436222 10.7609 0.121058 10.5186 0.0761445 10.1747C0.0258901 9.78994 0 9.39782 0 9C0 8.65322 0.281124 8.37209 0.627907 8.37209ZM1.02307 11.6244C1.34337 11.4915 1.71078 11.6433 1.8437 11.9636C2.10476 12.5927 2.44656 13.1803 2.85632 13.7134C3.06765 13.9883 3.01609 14.3825 2.74115 14.5938C2.4662 14.8052 2.07199 14.7536 1.86065 14.4787C1.38484 13.8597 0.987504 13.1768 0.683809 12.445C0.550884 12.1247 0.702778 11.7573 1.02307 11.6244ZM3.40616 15.2589C3.61749 14.9839 4.01171 14.9323 4.28665 15.1437C4.81973 15.5534 5.4073 15.8952 6.03635 16.1563C6.35665 16.2892 6.50855 16.6566 6.37562 16.9769C6.24269 17.2972 5.87529 17.4491 5.55499 17.3162C4.82321 17.0125 4.14035 16.6152 3.52133 16.1393C3.24638 15.928 3.19482 15.5338 3.40616 15.2589ZM7.28401 17.2199C7.32892 16.8761 7.64409 16.6337 7.98795 16.6786C8.31893 16.7218 8.65672 16.7442 9 16.7442C9.34678 16.7442 9.62791 17.0253 9.62791 17.3721C9.62791 17.7189 9.34678 18 9 18C8.60218 18 8.21006 17.9741 7.8253 17.9239C7.48144 17.8789 7.23909 17.5638 7.28401 17.2199Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
